"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMachineNetworkCidr = void 0;
const getMachineNetworkCidr = (machineNetwork) => {
    return `${machineNetwork.ip}/${machineNetwork.prefixLength}`;
};
exports.getMachineNetworkCidr = getMachineNetworkCidr;
//# sourceMappingURL=machineNetwork.js.map